<div class="back">
  <div id="wrapper" >
    <div class="join"><span class="blue">i</span>FIX <span class="ash" size="10">Account</span></div>
    <div class="lock"></div>

    <div class="clr">

      <div class="ash" size="3">Manage Your Customer Experience in Realtime</div>
    </div>
    <br>

    <div class="form-group">
      <input type="text" class="form-control" [(ngModel)]="loginName" placeholder="Enter User Id">
    </div>
    <div class="form-group">
<!--      <select class="form-control" [(ngModel)]="clientSelected" (change)="onClientChange($event.target.selectedIndex)">-->
<!--        <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>-->
<!--      </select>-->
      <input type="text" class="form-control" [(ngModel)]="clientSelected" placeholder="Enter Client Code">
    </div>
    <div class="form-group">
      <input type="password" class="form-control" [(ngModel)]="password" placeholder="Password">
    </div>
    <button class="btn btn-login" type="button" (click)="login()">Log In</button>&nbsp;
<!--    <button class="btn btn-login" type="button">Forgot Password</button>-->
    <br>
    <div  id="forgotpassword"><br>
      <div class="form-group">
        <input type="text" class="form-control" id="userName" placeholder="Username">
      </div>
      <button class="btn btn-login" >OK</button>&nbsp;
      <button class="btn btn-login" >Cancel</button>
    </div>
  </div>
  <div id="godaddy-security-badge" class="godaddy-security-right godaddy-security-light"></div>
</div>
<notifier-container></notifier-container>
